import {
  GET_SERVICES_SUCCESS,
  GET_SERVICES_FAIL,
  GET_SERVICES,
  GET_NOTIFICATION_CHANNEL_SUCCESS,
  GET_NOTIFICATION_CHANNEL_FAIL,
  GET_PAGERDUTY_SERVICES_SUCCESS,
  GET_PAGERDUTY_SERVICES_FAIL,
  GET_OPSGENIE_SERVICES_SUCCESS,
  GET_OPSGENIE_SERVICES_FAIL,
  GET_SPECIFIC_SERVICES_SUCCESS,
  GET_SPECIFIC_SERVICES_FAIL,
  GET_SPECIFIC_SERVICES,
  POST_SERVICE_SUCCESS,
  POST_SERVICE_FAIL,
  GET_REDIRECT_SLACK_SUCCESS,
  GET_REDIRECT_SLACK_FAIL,
  POST_UPDATE_SERVICE_SUCCESS,
  POST_UPDATE_SERVICE_FAIL,
  GET_INTEGRATION_KEYS,
  GET_INTEGRATION_KEYS_SUCCESS,
  GET_INTEGRATION_KEYS_FAIL,
  POST_CREATE_INTEGRATION_KEY,
  POST_CREATE_INTEGRATION_KEY_SUCCESS,
  POST_CREATE_INTEGRATION_KEY_FAIL,
  RESET_INTEGRATION_URL,
  GET_INTEGRATION_ACTION_URL,
  GET_INTEGRATION_ACTION_URL_SUCCESS,
  GET_INTEGRATION_ACTION_URL_FAIL,
  POST_RESEND_SERVICE_EMAIL_VERIFICATION,
  POST_RESEND_SERVICE_EMAIL_VERIFICATION_SUCCESS,
  POST_RESEND_SERVICE_EMAIL_VERIFICATION_FAIL,
  POST_TEST_NOTIFICATION,
  POST_TEST_NOTIFICATION_SUCCESS,
  POST_TEST_NOTIFICATION_FAIL,
  GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_SUCCESS,
  GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_FAIL,
  GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL,
  GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_SUCCESS,
  GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_FAIL,
  POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_SUCCESS,
  POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_FAIL,
  POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID,
  CREATE_UPDATE_TAG_SUCCESS,
  CREATE_UPDATE_TAG_FAIL,
  GET_TAG_VALUES_SUCCESS,
  GET_TAG_VALUES_FAIL,
  DELETE_TAG_VALUE_SUCCESS,
  DELETE_TAG_VALUE_FAIL,
  GET_ALL_KEY_NAMES_SUCCESS,
  GET_ALL_KEY_NAMES_FAIL,
  SET_MAINTENANCE_WINDOW_BY_ID, SET_MAINTENANCE_WINDOW_BY_ID_SUCCESS, SET_MAINTENANCE_WINDOW_BY_ID_FAIL,
} from "./actionTypes";
import { showNotification } from "components/Common/notification";

const INIT_STATE = {
  services: [],
  redirectSlack: [],
  specific_service: [],
  integrationKeys: [],
  integrationKey: [],
  notification_channel: [],
  pagerduty_services: [],
  opsgenie_services: [],
  integrationName: null,
  integrationType: null,
  integrationApiKey: null,
  integrationUrl: null,
  integrationActionUrl: null,
  error: null,
  communication_channels:[],
  communication_channels_by_id: [],
  update_bluejay_communication_channels_by_id: null,
  tagValues: [],
  tagKeys: [],
  updatedTag: null,
  deletedTag: null,
  maintenanceWindowId: {},
};

const Service = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload,
      }

    case GET_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NOTIFICATION_CHANNEL_SUCCESS:
      return {
        ...state,
        notification_channel: action.payload,
      }

    case GET_NOTIFICATION_CHANNEL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_PAGERDUTY_SERVICES_SUCCESS:
      return {
        ...state,
        pagerduty_services: action.payload,
      }

    case GET_PAGERDUTY_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_OPSGENIE_SERVICES_SUCCESS:
      return {
        ...state,
        opsgenie_services: action.payload,
      }

    case GET_OPSGENIE_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REDIRECT_SLACK_SUCCESS:
      return {
        ...state,
        redirectSlack: action.payload,
      }

    case GET_SPECIFIC_SERVICES:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SPECIFIC_SERVICES_SUCCESS:
      return {
        ...state,
        specific_service: action.payload
      }

    case GET_SPECIFIC_SERVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REDIRECT_SLACK_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_SERVICE_SUCCESS:
      state.services.push(action.payload)
      return {
        ...state,
        services: state.services,
      }

    case POST_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_UPDATE_SERVICE_SUCCESS:
      for (let i = 0; i < state.services.length; i++) {
        if (state.services[i].id === action.payload.id) {
          state.services[i].name = action.payload.name
          state.services[i].email_id = action.payload.email_id
          state.services[i].slack_channel_name = action.payload.slack_channel_name
          state.services[i].bluejay_oncall_policy = action.payload.bluejay_oncall_policy
          state.services[i].bluejay_team = action.payload.bluejay_team
          break;
        }
      }
      return {
        ...state,
        services: state.services,
      }

    case POST_UPDATE_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_INTEGRATION_KEYS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_INTEGRATION_KEYS_SUCCESS:
      return {
        ...state,
        integrationKeys: action.payload,
      }

    case GET_INTEGRATION_KEYS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_INTEGRATION_ACTION_URL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_INTEGRATION_ACTION_URL_SUCCESS:
      return {
        ...state,
        integrationActionUrl: action.payload,
      }

    case GET_INTEGRATION_ACTION_URL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_CREATE_INTEGRATION_KEY:
      return {
        ...state,
        error: action.payload,
      }

    case POST_CREATE_INTEGRATION_KEY_SUCCESS:
      const newIntegrationKey = action.payload['integration_key'];
      const existingKey = state.integrationKeys.find(
        key => key.id === newIntegrationKey.id
      );
      if (existingKey) {
        const integrationApiKey = action.payload['integration_api_key']
        const integrationUrl = action.payload['integration_url']
        const integrationName = action.payload['integration_key']['name']
        const integrationType = action.payload['integration_key']['integration_type']
        showNotification("warning", "Integration already exist for this integration type!");
        return {
          ...state,
          integrationKeys: state.integrationKeys,
          integrationName: integrationName,
          integrationType: integrationType,
          integrationApiKey: integrationApiKey,
          integrationUrl: integrationUrl
        }
      } else {
        state.integrationKeys.push(action.payload['integration_key'])
        const integrationApiKey = action.payload['integration_api_key']
        const integrationUrl = action.payload['integration_url']
        const integrationName = action.payload['integration_key']['name']
        const integrationType = action.payload['integration_key']['integration_type']
        showNotification("success", "Created Integration Key");
        return {
          ...state,
          integrationKeys: state.integrationKeys,
          integrationName: integrationName,
          integrationType: integrationType,
          integrationApiKey: integrationApiKey,
          integrationUrl: integrationUrl
        }
      }

    case POST_CREATE_INTEGRATION_KEY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_INTEGRATION_URL:
      return {
        ...state,
        integrationUrl: null,
      };

    case POST_RESEND_SERVICE_EMAIL_VERIFICATION:
      return {
        ...state,
        error: action.payload,
      }

    case POST_RESEND_SERVICE_EMAIL_VERIFICATION_SUCCESS:
      showNotification("success", action.payload.message);
      return {
        ...state,
        error: action.payload,
      }

    case POST_RESEND_SERVICE_EMAIL_VERIFICATION_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_TEST_NOTIFICATION:
      return {
        ...state,
        error: action.payload,
      }

    case POST_TEST_NOTIFICATION_SUCCESS:
      showNotification("success", action.payload.message);
      return {
        ...state,
        error: action.payload,
      }

    case POST_TEST_NOTIFICATION_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_SUCCESS:
      return {
        ...state,
        communication_channels: action.payload,
      }

    case GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL_FAIL:
      return {
        ...state,
        error: action.payload,
      }


    case GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_SUCCESS:
      return {
        ...state,
        communication_channels_by_id: action.payload,
      }

    case GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID_SUCCESS:
      return {
        ...state,
        update_bluejay_communication_channels_by_id: action.payload,
      }

    case POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID:
      return {
        ...state,
        error: action.payload,
      }
    case CREATE_UPDATE_TAG_SUCCESS:
      return { ...state, updatedTag: action.payload };

    case CREATE_UPDATE_TAG_FAIL:
      return { ...state, error: action.payload };

    case GET_TAG_VALUES_SUCCESS:
      return { ...state, tagValues: action.payload };

    case GET_TAG_VALUES_FAIL:
      return { ...state, error: action.payload };

    case DELETE_TAG_VALUE_SUCCESS:
      return { ...state, deletedTag: action.payload };

    case DELETE_TAG_VALUE_FAIL:
      return { ...state, error: action.payload };

    case GET_ALL_KEY_NAMES_SUCCESS:
      return { ...state, tagKeys: action.payload };

    case GET_ALL_KEY_NAMES_FAIL:
      return { ...state, error: action.payload };

    case SET_MAINTENANCE_WINDOW_BY_ID:
      return { ...state, error: action.payload };

    case SET_MAINTENANCE_WINDOW_BY_ID_SUCCESS:
      showNotification("success", action.payload.message);
      return { ...state, maintenanceWindowId: action.payload };

    case SET_MAINTENANCE_WINDOW_BY_ID_FAIL:
      return { ...state, error: action.payload };

    default:
      return state
  }
}


export default Service;